module.exports = __webpack_public_path__ + "static/media/OurProduct-PinkWave.9cd844aa.svg";